export const normalizeValue = value => {
  if (value === null) {
    return '';
  }
  return value;
};
const normalizeAssociationValue = value => {
  let normalizedValue = null;
  if (value) {
    if (Array.isArray(value)) {
      normalizedValue = value.map(v => +v);
    } else {
      normalizedValue = +value;
    }
  }
  return normalizedValue;
};
export const normalizeAssociationValueAsArray = value => {
  const normalizedValue = normalizeAssociationValue(value);
  if (!normalizedValue) {
    return null;
  } else if (!Array.isArray(normalizedValue)) {
    return [normalizedValue];
  }
  return normalizedValue.map(v => +v);
};

// Cast ObjectId values to strings for ReferenceLiteSearchSelect
export const normalizeAssociationValueAsString = (value, isMulti) => {
  if (!value) {
    return null;
  }
  if (isMulti) {
    if (Array.isArray(value)) {
      return value.map(v => String(v));
    }
    return [String(value)];
  } else {
    return String(value);
  }
};